import PropTypes from "prop-types";
import React, {  useState, useEffect } from "react";
import { Link, } from "react-router-dom";
import { connect, useDispatch, useSelector } from "react-redux";
import MenuCart from "./sub-components/MenuCart";
import { deleteFromCart } from "../../redux/actions/cartActions";
import { useHistory } from "react-router";
import { setProductsSearchText } from "../../redux/actions/productActions";
import SearchIcon from '../../assets/icons/search'
const IconGroup = ({
                     currency,
                     cartData,
                     wishlistData,
                     compareData,
                     deleteFromCart,
                     iconWhiteClass,
                     isAuthenticated
                   }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { searchText } = useSelector(({ searchText }) => searchText);
  // const { searchText } = useSelector(({ searchText }) => searchText);
  const [searchQuery, setSearchQuery] = useState(searchText);

  useEffect(() => {
    setSearchQuery(searchText);
  }, [searchText]);

  const handleClick = (e) => {
    e.currentTarget.nextSibling.classList.toggle("active");
  };
  const handleOpenSearchBar = (e) => {
    e.currentTarget.nextSibling.classList.toggle("active");
  };

  const triggerMobileMenu = () => {
    const offcanvasMobileMenu = document.querySelector(
      "#offcanvas-mobile-menu"
    );
    offcanvasMobileMenu.classList.add("active");
  };


  const handleRedirect = () => {
    dispatch(setProductsSearchText(searchQuery, history));
  };

  return (
   <div
      className={`header-right-wrap ${iconWhiteClass ? iconWhiteClass : ""}`}
    >
      <div className="same-style header-search d-none d-lg-block">
        <button
          className="search-active"
          onClick={(e) => handleOpenSearchBar(e)}
        >
          <SearchIcon color="#ff78b7" />
        </button>
        <div className="search-content">
          <div
            className="form-class"
            onKeyDown={(e) => {
              e.key === "Enter" && handleRedirect();
            }}
          >
            <input
              type="text"
              placeholder="Buscar por nombre o categoria"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <button
              type="button"
              className="button-search"
              onKeyDown={(e) => {
                e.key === "Enter" && handleRedirect();
              }}
              onClick={() => handleRedirect()}
            >
              <SearchIcon color="#ff78b7" />
            </button>
          </div>
        </div>
      </div>
      <div className="same-style mobile-off-canvas d-block d-lg-none">
        <button
          className="mobile-aside-button"
          onClick={() => triggerMobileMenu()}
        >
          <i className="pe-7s-menu" />
        </button>
      </div>
    </div>
  );
};

IconGroup.propTypes = {
  cartData: PropTypes.array,
  compareData: PropTypes.array,
  currency: PropTypes.object,
  iconWhiteClass: PropTypes.string,
  deleteFromCart: PropTypes.func,
  wishlistData: PropTypes.array,
};

const mapStateToProps = (state) => {
  return {
    currency: state.currencyData,
    cartData: state.cartData,
    wishlistData: state.wishlistData,
    compareData: state.compareData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    deleteFromCart: (item, addToast) => {
      dispatch(deleteFromCart(item, addToast));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(IconGroup);
